module.exports = __webpack_public_path__ + "img/nochanping.344e16d1.png";